import axios from 'axios';
import { QUICKBOOKS_CONFIG } from '../../../config/quickbooks';

// Make authenticated API call to QuickBooks
export const makeQBApiCall = async (accessToken, companyId, endpoint, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const url = `${QUICKBOOKS_CONFIG.BASE_API_URL}/v3/company/${companyId}/${endpoint}${queryString ? '?' + queryString : ''}`;
    
    const response = await axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error making QB API call:', error);
    throw error;
  }
};